"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.StyledLikert = void 0;

var _styledComponents = _interopRequireDefault(require("styled-components"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var StyledLikert = _styledComponents.default.div.withConfig({
  displayName: "Likertstyles__StyledLikert",
  componentId: "w3qeiy-0"
})(["text-align:center;padding-bottom:", ";"], function (props) {
  return props.theme.standardPadding;
});

exports.StyledLikert = StyledLikert;